import { render } from "./wind.svg.vue?vue&type=template&id=3bc8dad8"
import script from "./wind.svg.vue?vue&type=script&lang=js"
export * from "./wind.svg.vue?vue&type=script&lang=js"
script.render = render

export default script